import "./ProductNav.scss"
import React from "react"
import { observer } from "mobx-react"
import { addProductStore } from "../../stores"
import {
  PRODUCT_SELECT_STEP,
  PRODUCT_DESIGN_STEP,
  PRODUCT_EDITOR_STEP,
} from "./constants"

const ProductNav = () => {
  const { product, productDesigns, selectStep } = addProductStore
  return (
    <nav className="ProductNav">
      <ul>
        <li>
          <button onClick={e => selectStep(PRODUCT_SELECT_STEP)}>
            <label>Choose</label>
          </button>
        </li>
        <li>
          <button
            onClick={e => selectStep(PRODUCT_DESIGN_STEP)}
            disabled={!product}>
            <label>Design</label>
          </button>
        </li>
        <li>
          <button
            onClick={e => selectStep(PRODUCT_EDITOR_STEP)}
            disabled={Object.keys(productDesigns).length < 1}>
            <label>Configure</label>
          </button>
        </li>
      </ul>
    </nav>
  )
}

export default observer(ProductNav)



// WEBPACK FOOTER //
// ./src/products/add/ProductNav.js